// Local copy of @cx-modules/utils mergePersistentParams — keep in sync if the upstream implementation changes.
const PERSISTENT_QUERY_PARAMS = [
  'gtm_debug',
  'debug',
  'nocache',
  'gclid',
  'gclsrc',
  '_gl',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
] as const;

export function mergePersistentParams(targetUrl: string, requestUrl?: string): string {
  if (!requestUrl && typeof window === 'undefined') return targetUrl;
  try {
    const source = new URL(requestUrl || window.location.href);
    const params = new URLSearchParams(source.search);
    const toMerge: [string, string][] = [];
    for (const key of PERSISTENT_QUERY_PARAMS) {
      const val = params.get(key);
      if (val !== null) toMerge.push([key, val]);
    }
    if (toMerge.length === 0) return targetUrl;
    const isAbsolute = targetUrl.startsWith('http://') || targetUrl.startsWith('https://');
    const target = isAbsolute ? new URL(targetUrl) : new URL(targetUrl, source.origin);
    for (const [k, v] of toMerge) {
      if (!target.searchParams.has(k)) target.searchParams.set(k, v);
    }
    return isAbsolute ? target.toString() : target.pathname + target.search + target.hash;
  } catch {
    return targetUrl;
  }
}
